import {defineMessages} from 'react-intl';

export default defineMessages({
	casadeiStore: {
		id: 'storelocator.casadeiStore',
		defaultMessage: 'Casadei Store'
	},
	appointment: {
		id: 'storelocator.book',
		defaultMessage: 'Book an appointment'
	},
	storeType: {
		id: 'storelocator.storeType',
		defaultMessage: 'STORE TYPE',
	},
	categoryFilter: {
		id: 'storelocator.categoryFilter',
		defaultMessage: 'STORE CATEGORY',
	},
	storeService: {
		id: 'storelocator.storeService',
		defaultMessage: 'STORE SERVICES',
	},
	filters: {
		id: 'storelocator.filters',
		defaultMessage: 'FILTERS',
	},
	filtersSelected: {
		id: 'storelocator.filtersSelected',
		defaultMessage: '{filtersCounter} selected',
	},
	resultsMap: {
		id: 'storelocator.resultsMap',
		defaultMessage: 'Map',
	},
	list: {
		id: 'storelocator.list',
		defaultMessage: 'List',
	},
	storePersonalization: {
		id: 'storelocator.storePersonalization',
		defaultMessage: 'Personalization',
	},
	storeRepairs: {
		id: 'storelocator.storeRepairs',
		defaultMessage: 'Repair',
	},
	storeDutyFree: {
		id: 'storelocator.storeDutyFree',
		defaultMessage: 'Duty Free',
	},
	storeCnC: {
		id: 'storelocator.storeCnC',
		defaultMessage: 'Click & Collect',
	},
	allStores: {
		id: 'storelocator.allStores',
		defaultMessage: 'All Stores',
	},
	moreDetails: {
		id: 'storelocator.moreDetails',
		defaultMessage: 'More details',
	},
	inputPlaceholder: {
		id: 'storelocator.inputPlaceholder',
		defaultMessage: 'Search address or city',
	},
	resetButton: {
		id: 'storelocator.resetButton',
		defaultMessage: 'Reset all',
	},
	discoverButton: {
		id: 'storelocator.discoveryButton',
		defaultMessage: 'Discover store'
	},
	showResults: {
		id: 'storelocator.showResults',
		defaultMessage: 'See {results} results',
	},
	noResults: {
		id: 'storelocator.noResults',
		defaultMessage: 'We are sorry, no stores match your search. Try again',
	},
	geoLocalizationFailed: {
		id: 'storelocator.geoLocalizationFailed',
		defaultMessage: 'Error: The Geolocation service failed.',
	},
	noGeoLocalization: {
		id: 'storelocator.noGeoLocalization',
		defaultMessage: "Error: Your browser doesn't support geolocation.",
	},
	bags: {
		id: 'storelocator.category.bags',
		defaultMessage: 'Bags',
	},
	smallLeatherGoods: {
		id: 'storelocator.category.smallLeatherGoods',
		defaultMessage: 'Small Leather Goods',
	},
	belts: {
		id: 'storelocator.category.belts',
		defaultMessage: 'Belts',
	},
	sunGlasses: {
		id: 'storelocator.category.sunGlasses',
		defaultMessage: 'SunGlasses',
	},
	jewelry: {
		id: 'storelocator.category.jewelry',
		defaultMessage: 'Jewelry',
	},
	wallets: {
		id: 'storelocator.category.wallets',
		defaultMessage: 'Wallets',
	},
	keychain: {
		id: 'storelocator.category.keychain',
		defaultMessage: 'Keychain',
	},
	shoes: {
		id: 'storelocator.category.shoes',
		defaultMessage: 'Shoes',
	},
	watches: {
		id: 'storelocator.category.watches',
		defaultMessage: 'Watches',
	},
	mensCollection: {
		id: 'storelocator.category.mensCollection',
		defaultMessage: "Men's Collection",
	},
	perfume: {
		id: 'storelocator.category.perfume',
		defaultMessage: 'Perfume',
	},
	libraryFailure: {
		id: 'storelocator.libraryFailure',
		defaultMessage: 'Oops there was an error! Please try refreshing the page or try again later.'
	}
});
